import React from 'react'
import { useState } from 'react';
import { CONSTANTS } from 'utils/constant';
import { setPatientConsultationTab } from "store/slice/consultation-slice";
import { useDispatch } from "react-redux";
import Icons from 'Common/Icons';
import "./Appointment.scss";
import CommonButton from 'Components/CommonButton';
import { useTranslation, Trans } from "react-i18next";
import { PRIMARY_LANG } from "Common/constant";
import { LANG_STYLD_EXT } from "Common/constant";
import { TS_STYLD_COMPS } from "Common/constant";



function AppointmentInfoCard(props) {
  const { t, i18n } = useTranslation();
  const tgtLang = props.includePrimeLang
    ? i18n.language + "_" + PRIMARY_LANG
    : i18n.language;
  const tgtLangST = props.includePrimeLang ? tgtLang + LANG_STYLD_EXT : tgtLang;
    const determineInitialValue = () => {
        switch (true) {          
          case !props.patient_status?.care_plan?.plan_name || props.patient_status?.care_plan?.is_plan_expired:
            return 'subscription-plan';
          case props.patient_status?.care_plan?.plan_name && !props.patient_status?.care_plan?.is_plan_expired && !props.patient_status?.appointment?.is_appointment_eligible:
            return 'appointmentsBookedAlready';
          case props.patient_status?.appointment?.is_care_team_ticket_created:
            return 'preferred-clinician'; //'careTeamTicketRaised';
          case props.patient_status?.profile?.care_standard == "niyama"  && props.patient_status?.appointment?.is_first_time_appointment:
            return 'appointmentStepper';
          default:
            return 'preferred-clinician';
        }
    };
    const [niyamaPath, setIsNiyamaPath ] = useState(determineInitialValue);
    const dispatch = useDispatch();
    const redirectToStepperOrCareTeam = () => {
        if(niyamaPath == "appointmentsBookedAlready"){
          dispatch(setPatientConsultationTab("upcoming"));
          return;
        }
        let historyPush = true;
        if (niyamaPath == "appointmentStepper"){
            historyPush = false
        }
        props.redirectTo(niyamaPath,historyPush);
    }
    const appointmentInfo= {
        "appointmentStepper":{
            title: CONSTANTS.EVALUATION_360,
            content1:CONSTANTS.TAKE_EVALUATION_BY_AN_EXPERT_CONTENT_1,
            content2:CONSTANTS.EVALUATION_360_CONTENT_2,
            buttonLabel:CONSTANTS.BOOK_APPOINTMENT
        },
        "subscription-plan":{
            title: props.patient_status?.care_plan?.is_plan_expired ?  CONSTANTS.SUBSCRIBE_NIYAMA_CARE : CONSTANTS.TAKE_EVALUATION_BY_AN_EXPERT,
            content1: props.patient_status?.care_plan?.is_plan_expired ?  CONSTANTS.SUBSCRIBE_NIYAMA_CARE_CONTENT_1 : CONSTANTS.TAKE_EVALUATION_BY_AN_EXPERT_CONTENT_1,
            content2: props.patient_status?.care_plan?.is_plan_expired ? "" : CONSTANTS.TAKE_EVALUATION_BY_AN_EXPERT_CONTENT_2,
            buttonLabel:props.patient_status?.care_plan?.is_plan_expired ? CONSTANTS.CHOOSE_CARE_PLAN_DASHBOARD : CONSTANTS.TAKE_EVALUATION_PLAN,
        },
        "appointmentsBookedAlready":{
            title: CONSTANTS.APPOINTMENT_BOOKED_ALREADY,
            content1:CONSTANTS.APPOINTMENT_BOOKED_ALREADY_CONTENT_1,
            content2:CONSTANTS.APPOINTMENT_BOOKED_ALREADY_CONTENT_2,
            buttonLabel:CONSTANTS.GO_TO_APPOINTMENTS,
        },
        "careTeamTicketRaised":{
            title: CONSTANTS.EVALUATION_360,
            content1:CONSTANTS.EVALUATION_360_CONTENT_1,
            content2:CONSTANTS.EVALUATION_360_CONTENT_2,
            buttonLabel:"",
        },
        "preferred-clinician":{
            title: CONSTANTS.SELECT_CLINICIAN,
            content1:CONSTANTS.APPOINTMENT_SELECT_CLINICIAN_CONTENT,
            content2:"",
            buttonLabel:CONSTANTS.VIEW_CARE_TEAM
        },
    }
  return (
    <div className='eva-360-container'>
        <div className='eva-360-left-container'>
            <div className='eva-360-title'><Trans components={TS_STYLD_COMPS}>{t(appointmentInfo[niyamaPath].title,{lng:tgtLangST})}</Trans> </div>
            <div>
                    <div>
                        <div className='eva-360-txt-content'><Trans components={TS_STYLD_COMPS}>{t(appointmentInfo[niyamaPath].content1,{lng:tgtLangST})}</Trans></div>
                        {appointmentInfo[niyamaPath].content2 && <div className='eva-360-txt-content txt-content-2'><Trans components={TS_STYLD_COMPS}>{t(appointmentInfo[niyamaPath].content2,{lng:tgtLangST})}</Trans></div>}
                    </div>
            </div>
            {appointmentInfo[niyamaPath].buttonLabel && <CommonButton className="common-button-green eva-360-btn" label={<Trans components={TS_STYLD_COMPS}>{t(appointmentInfo[niyamaPath].buttonLabel,{lng:tgtLangST})}</Trans>} onClick={redirectToStepperOrCareTeam}/>}
        </div>
        <div className='eva-360-right-container'>
            <img className='eva-360-img' src={Icons.Evaluation_360_img}/>
        </div>
    </div>
  )
}

export default AppointmentInfoCard;
